import { EMPTY_STRING } from '@src/core/config';
import { UnitType } from '@src/core/enums';
import { getUnitType } from '@src/core/features/settings/units';
import { arcToFixed } from "./arc-to-fixed";
import type { ArcFormatOptions } from './arc-spatium';

export const arcVelocitasUnit = (unitType: UnitType = getUnitType()) => {
  if (unitType === UnitType.SI) return 'm/s';
  if (unitType === UnitType.IMPERIAL) return 'mph';
  return '';
};

export const arcVelocitas = (
  value?: number | null | string,
  options?: ArcFormatOptions & { unitType?: UnitType }
) => {
  const payload = Number(value);
  const displayUnit = options?.unitType ?? getUnitType();

  if (isNaN(payload)) return EMPTY_STRING;

  let display = payload;
  if (options?.fromSi && displayUnit === UnitType.IMPERIAL) {
    display = Number(arcToFixed(payload * 2.23694));
  } else {
    display = Number(arcToFixed(payload));
  }

  const request = arcToFixed(display);

  if (displayUnit === UnitType.SI) return request + ' m/s';
  if (displayUnit === UnitType.IMPERIAL) return request + ' mph';

  return EMPTY_STRING;
};
